import type { ComponentInfo } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const trustPilotStarsInputs = [
  {
    name: "sku",
    friendlyName: "Product SKU",
    type: "string",
    required: true,
  },
  {
    name: "height",
    friendlyName: "Widget Height",
    type: "string",
    defaultValue: "24px",
  },
  {
    name: "width",
    friendlyName: "Widget Width",
    type: "string",
    defaultValue: "280px",
  },
  {
    name: "starColor",
    friendlyName: "Star Color",
    type: "string",
    defaultValue: "#000000",
  },
  {
    name: "reviewNumber",
    friendlyName: "Review Number",
    type: "string",
    defaultValue: "5",
  },
  {
    name: "scrollToList",
    friendlyName: "Scroll To List",
    type: "string",
    enum: ["true", "false"],
    defaultValue: "true",
  },
  {
    name: "styleAlignment",
    friendlyName: "Alignment",
    type: "string",
    enum: ["left", "center", "right"],
    defaultValue: "center",
  },
] as const satisfies ComponentInfo["inputs"];

export type TrustPilotStarsProps = BuilderComponentProps<typeof trustPilotStarsInputs>;

export const TrustPilotStarsComponent: RegisteredComponent = {
  name: "TrustPilotStars",
  friendlyName: "Trust Pilot Stars",
  component: dynamic(async () =>
    withValidation(trustPilotStarsInputs, (await import("./TrustPilotStars")).TrustPilotStars, "TrustPilotStars")
  ),
  inputs: trustPilotStarsInputs,
};
